// #210 etapa 2 — los catorce permisos de un usuario reseller (y del techo de su empresa).
export const RESELLER_PERM_LIST = [
  { key: 'can_view_clients',    label: 'Ver clientes y backups',        group: 'Clientes' },
  { key: 'can_create_clients',  label: 'Crear clientes',                group: 'Clientes' },
  { key: 'can_edit_clients',    label: 'Editar clientes',               group: 'Clientes' },
  { key: 'can_generate_tokens', label: 'Generar tokens de instalación', group: 'Clientes' },
  { key: 'can_manage_users',    label: 'Gestionar usuarios de sus clientes', group: 'Usuarios' },
  { key: 'can_manage_account',  label: 'Administrar la cuenta de la empresa', group: 'Usuarios' },
  { key: 'can_manage_branding', label: 'Cambiar el branding', group: 'Empresa' },
  { key: 'can_explore_restore', label: 'Explorar y restaurar', group: 'Restauración' },
  { key: 'can_view_recovery_keys', label: 'Ver claves y kit de recuperación', group: 'Restauración' },
  { key: 'can_manage_servers',  label: 'Agregar / eliminar servidores', group: 'Infraestructura' },
  { key: 'can_manage_jobs',     label: 'Crear / editar / eliminar jobs', group: 'Infraestructura' },
  { key: 'can_view_reports',    label: 'Ver logs y reportes',           group: 'Reportes' },
  { key: 'can_view_billing',    label: 'Ver facturación y precios',     group: 'Reportes' },
  { key: 'can_manage_billing',  label: 'Gestionar planes y cuota (implica ver facturación)', group: 'Reportes' },
];

export const groupPerms = (list = RESELLER_PERM_LIST) => list.reduce((acc, p) => {
  (acc[p.group] = acc[p.group] || []).push(p);
  return acc;
}, {});

// Reglas de la consola para el mismo juego de permisos que valida el backend:
// can_manage_billing implica can_view_billing.
export const withImplications = (perms) => (
  perms.can_manage_billing ? { ...perms, can_view_billing: true } : perms
);
